import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://www.getdialedin.golf";

export default function Seo({ title, description }) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    const set = (sel, attr, val) => {
      const el = document.querySelector(sel);
      if (el && val) el.setAttribute(attr, val);
    };
    set('meta[name="description"]', "content", description);
    set('link[rel="canonical"]', "href", `${BASE}${pathname === "/" ? "/" : pathname}`);
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:url"]', "content", `${BASE}${pathname}`);
    set('meta[name="twitter:title"]', "content", title);
    set('meta[name="twitter:description"]', "content", description);
  }, [title, description, pathname]);
  return null;
}
